import About from "../components/home/about";
import Hero from "../components/home/hero";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HomeArticles from "../components/home/articles";
import Join from "../components/home/join";
import { useSearchParams } from "react-router-dom";
import { useNotification } from "../components/individuals/NotificationProvider";
import { useEffect } from "react";

export default function Home() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { showNotification } = useNotification();
  useEffect(() => {
    const form = searchParams.get("form");
    if (form) {
      setSearchParams({}, { replace: true });
      showNotification("Your inquiry has been sent.", "success");
    }
  }, [searchParams, setSearchParams, showNotification]); // this will run twice in dev mode, but not in production. Quirky (but intentional) behavior of React.StrictMode and useEffect. See https://stackoverflow.com/questions/72238175/why-useeffect-running-twice-and-how-to-handle-it-well-in-react
  return (
    <div className="w-full h-full">
      <Navbar />
      <Hero />
      <About />
      <Join />
      <HomeArticles />
      <div className="min-h-[10vh]"></div>
      <Footer />
    </div>
  );
}
